/**
 * Phase 32 — Lightweight CTA tracker.
 * Privacy-friendly: no third-party scripts, no cookies.
 * Backend stores only IP-prefix (first 3 octets) for de-duplication.
 *
 * Usage:
 *   import { trackCta, useTrackView } from '../utils/tracker';
 *   useTrackView('hero');                       // page view
 *   <Link onClick={() => trackCta('nav-cta')} ...>
 */
import { useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _emitted = new Set();

export async function trackCta(ctaId, eventType = 'click', { dedup = false } = {}) {
  try {
    if (!ctaId) return;
    const key = `${ctaId}::${eventType}`;
    if (dedup && _emitted.has(key)) return;
    _emitted.add(key);
    const page = window.location.pathname.replace(/[^a-z0-9/_:-]/gi, '').slice(0, 80);
    await axios.post(`${API}/analytics/track`,
      { cta_id: ctaId, event_type: eventType, page },
      { withCredentials: true }
    );
  } catch (_) { /* never break UX over analytics */ }
}

export function useTrackView(ctaId) {
  useEffect(() => {
    if (!ctaId) return;
    trackCta(ctaId, 'view', { dedup: true });
  }, [ctaId]);
}
